// extracted by mini-css-extract-plugin
export default {"container":"home_container__ZFw20","left":"home_left__sGCnI","center":"home_center__Jgvd1","right":"home_right__jgpek","userInfoBox":"home_userInfoBox__9FEfS"};